<template>
    <div class="card">
        <div class="richTable is-simple py-3 px-4">
            <div class="richTable-head richTable-col approval-item justify-content-between">
                <div>
                    <h2 class="h6">Zgoda na logowanie serwisowe</h2>
                    <p class="a-text">
                        {{
                            serviceLoginConsent &&
                                serviceLoginConsent.dict_consents.content
                        }}
                    </p>
                </div>
            </div>
            <div class="richTable-body">
                <div class="richTable-row flex-column align-items-start">
                    <radio-input
                        id="service-login-consent-radio-0"
                        :data="{
                            label: 'Logowanie w moim imieniu zablokowane',
                            value: 'DISABLED'
                        }"
                        name="service-login-consent-radio"
                        @change="onServiceLoginConsentChange"
                        :value="checkedConsent"
                    />
                    <radio-input
                        id="service-login-consent-radio-1"
                        :data="{
                            label: 'Zezwolenie na logowanie do końca dnia',
                            value: 'END_OF_DAY'
                        }"
                        name="service-login-consent-radio"
                        @change="onServiceLoginConsentChange"
                        class="mt-4"
                        :value="checkedConsent"
                    />
                    <radio-input
                        id="service-login-consent-radio-2"
                        :data="{
                            label: 'Zezwolenie na logowanie do odwołania',
                            value: 'ENABLED'
                        }"
                        name="service-login-consent-radio"
                        @change="onServiceLoginConsentChange"
                        class="mt-4"
                        :value="checkedConsent"
                    />
                </div>
                <div class="d-flex justify-content-end mt-4 w-100">
                    <the-btn
                        :disabled="originalConsentState === checkedConsent"
                        class="btn-secondary ml-auto px-4"
                        @click.native="onConsentSave"
                    >
                        Zapisz
                    </the-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        serviceLoginConsent() {
            return this.$store.getters.getServiceLoginConsent
        },
        serviceLoginConsentState() {
            let state = 'N'
            if (this.checkedConsent !== 'DISABLED') state = 'Y'
            return state
        }
    },
    watch: {
        serviceLoginConsent: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.originalConsentState = val.value || 'DISABLED'
                    this.checkedConsent = this.originalConsentState
                }
            }
        }
    },
    data() {
        return {
            checkedConsent: null,
            originalConsentState: null
        }
    },
    methods: {
        async onConsentSave() {
            await this.$store.dispatch('saveServiceLoginConsent', {
                state: this.serviceLoginConsentState,
                service_login_status: this.checkedConsent
            })
            this.$store.dispatch('addNotification', {
                type: 'success',
                content: 'Zapisano zgodę'
            })
            this.originalConsentState = this.checkedConsent
        },
        onServiceLoginConsentChange(e) {
            this.checkedConsent = e
        }
    }
}
</script>
